module.exports = __webpack_public_path__ + "static/media/Luciano_Om.3a23b5a0.png";